import { makeStyles } from "@mui/styles";

const useStyles = makeStyles({
  swipeBackground: {
    width: "240px",
    height: "0",
    position: "relative",
    top: "-42px",
    overflow: "visible",
    zIndex: (props) => props.zIndex || 0,
  },
  swipeBackgroundInner: {
    textAlign: "right",
    color: "#fff",
    display: "block",
    height: "42px",
    width: "100%",
    backgroundColor: "#71B6BC",
    top: "42px",
    position: "relative",
    opacity: (props) => props.opacity || 0,
  },
  iconStyles: {
    position: "relative",
    top: "7.5px",
  },
});

export default function SwipeWrapper(props) {
  const { children, icon } = props;

  const classes = useStyles(props);

  return (
    <>
      {children}
      <div className={classes.swipeBackground}>
        <div className={classes.swipeBackgroundInner}>
          <div className={classes.iconStyles}>{icon}</div>
        </div>
      </div>
    </>
  );
}
